<template>
  <div>
    <event-header :event="event" />

    <div class="mt-8 rounded-lg shadow-lg overflow-hidden" id="event-manager"></div>
  </div>
</template>

<script>
import EventHeader from "@/components/EventHeader";
export default {
  components: {
    EventHeader
  },

  computed: {
    event() {
      return this.$store.state.editor.event;
    },
    organizer() {
      return this.$store.state.account.currentAccount;
    }
  },

  mounted() {
    this.getSeatsio().then(() => this.renderChart());
  },
  beforeDestroy() {
    this.destroyChart();
  },

  methods: {
    renderChart() {
      this.chart = new seatsio.EventManager({
        divId: "event-manager",
        secretKey: this.organizer.seats_io_workspace_secret,
        event: this.event.id.toString(),
        mode: "manageForSaleConfig",
        language: "de"
      }).render();
    },

    getSeatsio() {
      return typeof seatsio !== "undefined"
        ? Promise.resolve(seatsio)
        : this.loadSeatsio();
    },
    loadSeatsio() {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.onload = () => resolve(seatsio);
        script.onerror = () => reject(`Could not load ${script.src}`);
        script.src = "https://cdn.seatsio.net/chart.js";
        document.head.appendChild(script);
      });
    },
    destroyChart() {
      if (this.chart && this.chart.state !== "DESTROYED") {
        this.chart.destroy();
      }
    }
  }
};
</script>
